import React, { useState, useRef, useEffect } from 'react';
import engage from '../../assets/services/engage/Picture1.png';
import impact1 from '../../assets/services/engage/Screenshot 2025-03-21 205039.png';
import impact2 from '../../assets/services/engage/Screenshot 2025-03-19 140000.png';
import ScrollToHashElement from '../ScrollToHashElement'; // 👈 Import here

const EngageSection = () => {
  const [activeCard, setActiveCard] = useState(0);
 const touchStartX = useRef(null);
 const touchStartY = useRef(null);
 const touchEndX = useRef(null);
 const touchEndY = useRef(null);
 
 
   const carouselRef = useRef(null);
 
   // Handle touch events for swipe
 const handleTouchStart = (e) => {
   touchStartX.current = e.touches[0].clientX;
   touchStartY.current = e.touches[0].clientY;
 };
 
 
 const handleTouchMove = (e) => {
   touchEndX.current = e.touches[0].clientX;
   touchEndY.current = e.touches[0].clientY;
 };
 
 const handleTouchEnd = () => {
   if (
     touchStartX.current === null ||
     touchEndX.current === null ||
     touchStartY.current === null ||
     touchEndY.current === null
   )
     return;
 
   const diffX = touchStartX.current - touchEndX.current;
   const diffY = touchStartY.current - touchEndY.current;
 
   // Check if horizontal movement is greater than vertical movement
   if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 5) {
     if (diffX > 0) {
       // Swipe left
       setActiveCard((prev) => (prev === 1 ? 0 : prev + 1));
     } else {
       // Swipe right
       setActiveCard((prev) => (prev === 0 ? 1 : prev - 1));
     }
   }
 
   touchStartX.current = null;
   touchEndX.current = null;
   touchStartY.current = null;
   touchEndY.current = null;
 };

  // Auto-scroll to active card
  // useEffect(() => {
  //   if (carouselRef.current) {
  //     carouselRef.current.scrollTo({
  //       left: activeCard * carouselRef.current.offsetWidth,
  //       behavior: 'smooth'
  //     });
  //   }
  // }, [activeCard]);

      useEffect(() => {
      if (carouselRef.current) {
        carouselRef.current.scrollTo({
          left: activeCard * carouselRef.current.offsetWidth,
          behavior: 'smooth'
        });
      }
    }, [activeCard]);

  return (
    <div id="engage " className="w-full bg-white mt-10 my-20 md:px-24 px-4">
      <ScrollToHashElement/>
      <h2 className="text-[#AD2F3B] text-[32px] font-bold max-[440px]:text-[20px] text-center mb-2">
        ENGAGE
      </h2>
      <p className="text-center text-[24px] font-semibold max-[440px]:text-[14px] text-gray-700 mb-[50px]">
        Conferences & Events
      </p>

      {/* Description Box */}
      <div className="flex gap-[50px] md:mx-24 flex-col md:flex-row max-[440px]:flex-col-reverse mb-20">
        <div className="border-2 h-[500px] border-gray-300 w-[1500px] max-[440px]:w-full max-[440px]:text-[14px] max-[440px]:py-10 rounded-[20px] px-8 pt-10 flex-1 text-[22px] font-medium leading-relaxed text-gray-900 shadow-[0_-8px_10px_-10px_rgba(0,0,0,0.3),0_8px_10px_-10px_rgba(0,0,0,0.3)]">
          <ul className="list-disc pl-4 space-y-8">
            <li>Curate bespoke, thematic cultural performances for corporate events and conferences.</li>
            <li>Create immersive experiences that align with event goals and narratives.</li>
            <li>Facilitate meaningful engagement with audiences through powerful storytelling.</li>
            <li>
              <span className="font-semibold">Clients:</span> Corporates, Industrial & ESG/ Development Sector Organisations, Academia.
Add logos of GIZ, UNICEF, INK

            </li>
          </ul>
        </div>

        {/* Image */}
        <div className="w-full md:w-[500px] h-[500px] max-[440px]:w-full max-[440px]:h-[395px] bg-gray-200">
          <img
            src={engage}
            alt="Engage Service"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Impact Highlights Section Box */}
      <div className="border-2 border-gray-300 py-10 text-[22px] text-gray-900 shadow-[0_-8px_10px_-10px_rgba(0,0,0,0.3),0_8px_10px_-10px_rgba(0,0,0,0.3)] w-full mx-auto mb-20 rounded-[20px] px-4 md:px-10 md:w-[1300px] md:mx-auto">
        <h3 className="text-[#AD2F3B] text-[30px] max-[440px]:text-[20px] font-bold text-center mb-12">
          Impact Highlights
        </h3>

        {/* Mobile Carousel */}
        <div className="md:hidden relative">
          <div
            ref={carouselRef}
            className="flex overflow-x-hidden scroll-snap-x-mandatory scrollbar-hide"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            style={{ scrollSnapType: "x mandatory" }}
          >
            {/* Card 1 */}
            <div className="w-full flex-shrink-0 px-2 scroll-snap-align-start">
              <div className="h-auto mb-10">
<img
  src={impact2}
  alt="GIZ (Aquaculture Conference)"
  className="rounded-xl mb-4 w-full bg-[#FBF1F3] object-contain"
  style={{ height: "auto", objectPosition: "center" }}
/>


                <h4 className="text-[#AD2F3B] text-[20px] font-bold mb-6 text-center">
                  GIZ (Bhubaneswar)
                </h4>
              </div>
              <div className="space-y-8 text-left px-2 text-[14px]">
                <p>
                  <span className="font-semibold">Theme:</span> Curated a Mayurbhanj Chhau performance depicting lives and livelihoods of fisherfolk at a multi-stakeholder aquaculture conference at Hotel Mayfair
                </p>
                <p>
                  <span className="font-semibold">Outreach:</span> Key stakeholders in sustainable aquaculture such as Government agencies, NGOs and start-ups
                </p>
                <p>
                  <span className="font-semibold">Impact:</span> Enhanced stakeholder engagement and facilitated stronger connection and networking among stakeholders 
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="w-full flex-shrink-0 px-2 scroll-snap-align-start">
              <div className="h-auto mb-10">
                {/* <img
                  src={impact1}
                  alt="INK Talks (TiE Global Summit)"
                  className="rounded-xl mb-4 w-full"
                  style={{ height: "300px", objectFit: "cover" }}
                /> */}
                <img
  src={impact1}
  alt="INK Talks (TiE Global Summit)"
  className="rounded-xl mb-4 w-full bg-[#FBF1F3] object-contain"
  style={{ height: "auto", objectPosition: "center" }}
/>
                <h4 className="text-[#AD2F3B] text-[20px] font-bold mb-6 text-center">
                  INK Talks (Bengaluru)
                </h4>
              </div>
              <div className="space-y-8 text-left px-2 text-[14px]">
                <p>
                  <span className="font-semibold">Theme:</span>Powerful folk Kamsale performance at the session on Power of Culture in a Changing World at the TiE Global Summit 2024 at Bangalore International Centre
                </p>
                <p>
                  <span className="font-semibold">Outreach:</span> International audience of over 200 innovators and thought leaders 
                </p>
                <p>
                  <span className="font-semibold">Impact:</span> Created a unique experience and demonstrated how creative expression can offer hope, foster community, and preserve heritage.
                </p>
              </div>
            </div>
          </div>

          {/* Dot Indicators */}
          <div className="flex justify-center mt-6 space-x-3">
            {[0, 1].map((index) => (
              <button
                key={index}
                onClick={() => setActiveCard(index)}
                className={`w-4 h-4 rounded-full ${
                  activeCard === index ? "bg-[#AD2F3B]" : "bg-gray-300"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex flex-col md:flex-row justify-between gap-[40px]">
          {/* Card 1 */}
          <div className="w-full md:w-[600px]">
            <div className="h-[400px] mb-10">
              <img
                src={impact2}
                alt="GIZ (Aquaculture Conference)"
                className="rounded-xl mb-8 w-full"
                style={{ height: "300px", objectFit: "cover" }}
              />
              <h4 className="text-[#AD2F3B] text-[24px] font-bold mb-10 text-center">
                GIZ (Bhubaneswar)
              </h4>
            </div>
            <div className="space-y-6 text-left px-4">
             <p>
                  <span className="font-semibold">Theme:</span> Curated a Mayurbhanj Chhau performance depicting lives and livelihoods of fisherfolk at a multi-stakeholder aquaculture conference at Hotel Mayfair
                </p>
                <p>
                  <span className="font-semibold">Outreach:</span> Key stakeholders in sustainable aquaculture such as Government agencies, NGOs and start-ups
                </p>
                <p>
                  <span className="font-semibold">Impact:</span> Enhanced stakeholder engagement and facilitated stronger connection and networking among stakeholders 
                </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="w-full md:w-[600px]">
            <div className="h-[400px] mb-10">
              <img
                src={impact1}
                alt="INK Talks (TiE Global Summit)"
                className="rounded-xl mb-8 w-full"
                style={{ height: "300px", objectFit: "cover" }}
              />
              <h4 className="text-[#AD2F3B] text-[24px] font-bold mb-10 text-center">
                INK Talks (Bangalore)
              </h4>
            </div>
            <div className="space-y-6 text-left px-4">
                <p>
                  <span className="font-semibold">Theme:</span>Powerful folk Kamsale performance at the session on Power of Culture in a Changing World at the TiE Global Summit 2024 at Bangalore International Centre
                </p>
                <p>
                  <span className="font-semibold">Outreach:</span> International audience of over 200 innovators and thought leaders 
                </p>
                <p>
                  <span className="font-semibold">Impact:</span> Created a unique experience and demonstrated how creative expression can offer hope, foster community, and preserve heritage.
                </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EngageSection;